import { useRecoilState } from 'recoil';

import { Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

import { exitModalState } from '../../../atoms';
import { useHistory } from 'react-router';
import { Lease } from '../../models';

export default function ExitModal({ path = '' }: { path?: string }) {
  const history = useHistory();

  const [isExitModalOpen, setIsExitModalOpen] = useRecoilState(exitModalState);

  function onExitModalClose() {
    setIsExitModalOpen(false);
  }

  function onExitWithoutSavingClick() {
    onExitModalClose();

    if (path) {
      window.location.href = path; // external redirect shouldn't use history.push
    } else {
      history.push(Lease.getDashboardPath());
    }
  }

  return (
    <Modal
      size={{ base: 'fullScreen', md: 'xs' }}
      open={isExitModalOpen}
      onOpenChange={(open) => {
        if (!open) {
          onExitModalClose();
        }
      }}
      header={<Heading level={1}>Exit without saving?</Heading>}
      body={<Paragraph>If you leave now, your progress won’t be saved and you’ll need to start over.</Paragraph>}
      footer={
        <ButtonGroup aria-label="exit options">
          <TextButton tone="brand" onClick={onExitModalClose}>
            Cancel
          </TextButton>
          <Button tone="brand" emphasis="filled" onClick={onExitWithoutSavingClick}>
            Exit without saving
          </Button>
        </ButtonGroup>
      }
    />
  );
}
